import React from "react";
import "./Head.css";
function Head() {
  return (
    <div className="head">
      <h1>|| Quizz ||</h1>
    </div>
  );
}

export default Head;
